import type { MouseEvent } from "react";
import { useCallback } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { useSiteSelectorContext } from "@/components/site-selector-modal";
import WplButton from "@/components/wpl/button/src";

type TemplateCtaButtonsProps = {
    name: string;
    pluginModuleKey: string;
};

const ctaContainerStyles = css({
    "alignItems": "center",
    "display": "flex",
    "gap": "36px",
    "justifyContent": "flex-start",
    "@media(max-width: 768px)": {
        justifyContent: "center"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".cta-button": {
        flexGrow: 1,
        minHeight: "40px",
        borderRadius: "40px",
        fontSize: "1rem"
    }
});

export const TemplateCtaButtons = ({
    name,
    pluginModuleKey
}: TemplateCtaButtonsProps) => {
    const intl = useIntl();
    const { openModalForTemplate } = useSiteSelectorContext();

    const buttonText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.useTemplate",
        defaultMessage: "Use template"
    });

    const navigateToSignup = useCallback(
        (event: MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            event.preventDefault();

            openModalForTemplate({
                templateId: pluginModuleKey ?? "",
                templateName: name ?? "",
                productKey: ProductKeys.CONFLUENCE
            });
        },
        [openModalForTemplate, name, pluginModuleKey]
    );

    return (
        <div css={ctaContainerStyles}>
            <WplButton
                className="cta-button"
                onClick={navigateToSignup}
                size="small"
                text={buttonText}
            />
        </div>
    );
};
